import { ConfiguratorSectionComponents } from "src/components/views/erp/configurator/configuratorForm/components/types/ConfiguratorSectionComponents.ts";
import {
	TransformedConfigurationComponent,
} from "src/api/generated/erp/configurator/componentTransformation/model/transformedConfigurationComponent.ts";
import { NonTabTransformedConfigurationComponent } from "src/components/views/erp/configurator/configuratorForm/components/types/NonTabTransformedConfigurationComponent.tsx";
import { ConfiguratorTabWithChildren } from "./ConfiguratorTabWithChildren";

export function groupConfiguratorComponentsToTabsAndSections(
	allComponents: TransformedConfigurationComponent[],
): ConfiguratorTabWithChildren[] {
	return allComponents.reduce<ConfiguratorTabWithChildren[]>((acc, component) => {
		if (component.type !== "tab") return acc;

		const childComponents = allComponents.reduce((acc, c) => {
			if (c.type === "tab") return acc;
			if (c.layout.parentTabComponentId !== component.configurationComponentId) return acc;
			return [...acc, c];
		}, Array<NonTabTransformedConfigurationComponent>());

		const sections = groupConfiguratorComponentsToSections(childComponents);
		return [
			...acc,
			{
				tab: component,
				sections: sections,
			},
		];
	}, []);
}

function groupConfiguratorComponentsToSections(
	components: NonTabTransformedConfigurationComponent[],
): ConfiguratorSectionComponents[] {
	const initial: ConfiguratorSectionComponents = {
		sectionBreakComponent: undefined,
		childComponents: [],
	};
	return components.reduce(
		(acc, component) => {
			if (component.type === "sectionBreak") {
				return [
					...acc,
					{
						sectionBreakComponent: component,
						childComponents: [],
					},
				];
			} else {
				const currentSection = acc[acc.length - 1]!;
				currentSection.childComponents.push(component);
				return acc;
			}
		},
		[initial],
	);
}
